<template>
    <!-- <cus-dialog ref="form-saveas" class="form-table-h500" :title="哈哈" :visible.sync="visibleSync" @confirm="SaveAs" :close-on-click-modal="false" width="80%" :okVisible="okVisible">

    </cus-dialog> -->

    <form-dialog ref="form-saveas" :title="currentItem.title" :data="currentItem.data" width="80%" :visible.sync="visibleSync" :columns="columnList" @confirm="SaveAs"></form-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `CompoundDrugEdit`,
    props: {
        visible: { type: Boolean, default: () => false },
        currentItem: { type: Object }
    },
    data() {
        return {
            title: `麻醉计费模板另存为`,
            item_configs: []
        }
    },
    created() {
    },
    mounted() {

    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `sys_enums`]),
        visibleSync: {
            get: function() {
                console.log(this.currentItem)
                console.log(`sssadasd`)
                console.log(this.currentItem.data)

                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        },
        columnList() {
            console.log(this.data)
            return [
                {
                    type: `string`,
                    prop: `label`,
                    label: `组合名称`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    readonly: true,
                    default: `自动生成`,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `value`,
                    label: `编码`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `table`,
                    prop: `items`,
                    label: `项目`,
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `编码`,
                            isKey: true
                        },
                        {
                            type: `remoteselect`,
                            prop: `dic_drug`,
                            label: `名称`,
                            isListable: true,
                            options: `/api/AcisSystem/Drug/Search`,
                            change: (that, { row, area }) => {
                                let req = this.myaxios.get(`/api/AcisSystem/Drug/Get/${row.dic_drug.value}`)
                                req.then(data => {
                                    this.$set(row, `code`, data.code)
                                }).catch()
                            },
                            readonly: false
                        },
                        {
                            type: `string`,
                            prop: `code`,
                            label: `编码`,
                            isListable: true,
                            readonly: true
                        }, {
                            type: `string`,
                            prop: `abbr`,
                            label: `abbr`,
                            isListable: false,
                            readonly: false
                        }
                    ],
                    colspan: 24,
                    default: []
                }
            ]
        }
    },
    methods: {
        saveOne(datas) {
            console.log(datas)
            return new Promise((resolve, reject) => {
                let req = this.myaxios.put(`api/AcisSystem/CompoundDrug/PutMany`, datas)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        SaveAs(row) {
            console.log(`row`)
            console.log(row)
            console.log(this.currentItem)
            if (row.items && row.items.length > 0) {
                let r = _.map(row.items, d => {
                    return {
                        dic_drug_id: d.dic_drug.value,
                        old_code: this.currentItem.oldcode,
                        group_name: row.label,
                        group_code: row.value
                    }
                })
                this.saveOne(r).then(data => {
                    this.$emit(`save-success`)
                    this.visibleSync = false
                })
            }
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Drug/CompoundDrugEdit.vue